<template>
<div>
    <div :class="[showLogin?'in':'','modal','fade','vue-login-modal']"  id="login-modal" class="" tabindex="-1" role="dialog" style="display: block; padding-right: 8px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <ul class="nav nav-tabs">
                        <li class="nav-tab-login active">
                            <a href="#tab_login" data-toggle="tab">
                                登录
                            </a>
                        </li>
                        
                    </ul>
                    <button type="button" class="close"  @click="setshowLoginFalse()"  data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <div class="tabbable-line">
                        <div class="tab-content">
                            <div class="tab-pane active" id="tab_login">
                                <div class="form-horizontal">
                                    <form  id="lform" method="post" >
                                        <input id="ReturnUrl" name="ReturnUrl" type="hidden" value=""><input id="Action" name="Action" type="hidden" value="LoginModal">
                                        <div class="LoginFailed">
                                            <!-- <span class="field-validation-valid" data-valmsg-for="LoginFailed" data-valmsg-replace="true"></span> -->
                                            <span class="field-validation-error" v-if="msg">{{msg}}</span>
                                        </div>
                                        <div class="form-group">
                                            <div class="input-icon">
                                                <input class="form-control placeholder-input" v-model="uname" data-val="true" data-val-required="请输入用户名或手机号" id="UsernameOrEmailAddress" name="UsernameOrEmailAddress" placeholder="请输入用户名/手机号" type="text" value="">
                                                <span class="field-validation-valid text-danger"  v-if="msg1">{{msg1}}</span>
                                            </div>

                                        </div>
                                        <div class="form-group">
                                            <div class="input-icon">

                                                <input class="form-control placeholder-input" v-model="pwd" data-val="true" data-val-required="请输入密码" id="LoginPassword" name="LoginPassword" placeholder="请输入密码" type="password">
                                                <span class="field-validation-valid text-danger"  v-if="msg2">{{msg2}}</span>
                                            </div>

                                        </div>
                                        <div class="form-group" style="height: 40px;">
                                            <div class="checkbox">
                                                <label>
                                                    <input data-val="true" data-val-required="RememberMe 字段是必需的。"  v-model="RememberMe" id="RememberMe" name="RememberMe" type="checkbox" value="true"><input name="RememberMe" type="hidden" value="false"> 自动登录
                                                </label>
                                                <a href="/account/forgetpassword" style="float: right; color: #e51c23" target="_blank">忘记密码？</a>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <button  type="button" class="btn btn-default" @click="login()">登 录</button>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
      return{
          uname:'',
          pwd:'',
          RememberMe:false,
          loginData:{},
          msg:'',
          msg1:'',
          msg2:''
      }
  },
  computed:{
      showLogin(){
          return this.$store.state.showLogin;
      }
  },
   created(){
     // this.loginData = await this.getCurrentuserInfo()
  },
  methods: {
    login: async function(){ //登录
      this.msg = ''
      this.msg1 = ''
      this.msg2 = ''
      if(this.uname =='') this.msg1 = '请输入用户名或手机号'
      if(this.pwd == '') this.msg2 = '请输入密码'
      if(this.uname!='' && this.pwd!=''){
        var res = await this.loginAction(this.uname,this.pwd,this.RememberMe);
        if(res.result == 1){
            this.$store.dispatch('setShowLogin', false);
            this.getCurrentuserInfo()
        // this.$store.dispatch('setLogin', true);
        } else{
            this.msg = '登录失败!用户名或密码无效'
        }
      }
    },
    setshowLoginFalse(){
        // console.log(333)
        this.$store.dispatch('setShowLogin', false);
    },
   
    loginAction(uname,pwd,RememberMe){
        var postdata = {
            ReturnUrl: '',
            Action: 'LoginModal',
            UsernameOrEmailAddress: uname,
            LoginPassword: pwd,
            RememberMe: RememberMe,
            'X-Requested-With': 'XMLHttpRequest'
        }
        return new Promise((resolve, reject) => {
                this.$api.post('/Account/LoginVue',postdata, Response => {
                resolve(Response)
                },error=>{
                reject(error)
                })
            })
    },
    getCurrentuserInfo(){
        this.$api.post('/api/services/app/session/GetCurrentLoginInformations',null, Response => {
           this.$store.dispatch('setUserInfo', Response.result.user);
        },error=>{
           console.log(error)
        })
    }
  },
  
  
}
</script>

<style scoped>
/* .el-menu-title{
  font-size: 18px;
  font-weight: bold;
  color:#000000;
} */
</style>